import {defineField} from 'sanity'
import defaultBlocks from './default-blocks'

export default defineField({
  name: 'portableTextVideoContent',
  type: 'array',
  of: [defaultBlocks, {type: 'inline-banner'}],
})
